<template>
  <div id="screen" class="mainframe">
    <vue-scroll>
      <user-info :aircraft="aircraftName" :procedures="procedures.length" @close-screen="screenOff"/>
      <div class="title">
        <h3 class="text-left">Your procedures for {{ aircraftName }}</h3>

        <div class="blind_exam_button">
          <span style="cursor: pointer; margin-right: 10px" :style="'color:' + (blindExamMode?$colors.yellow:'#BBB')" @click="toggleBlindExamMode(!blindExamMode)">Blind Exam</span>
          <v-switch style="display: inline-block" @change="toggleBlindExamMode" :input-value="blindExamMode"></v-switch>

        </div>

      </div>

      <v-timeline dense>
        <v-slide-x-reverse-transition
            group
            hide-on-leave
        >
          <v-timeline-item
              v-for="(procedure, index) in procedures"
              :key="index"
              small
              fill-dot
              @click="startSlider(procedure)"
          >

            <v-list-item
                @click="startSlider(procedure)"
                class="list-item"
            >
              <v-list-item-content>
                <v-list-item-title v-text="procedure.name"
                                   style="text-align: left; font-weight: bold; color: rgb(13, 71, 161)"></v-list-item-title>
              </v-list-item-content>

              <GraduationIcon :completed="isCompleted(procedure)"/>

            </v-list-item>
          </v-timeline-item>
        </v-slide-x-reverse-transition>
      </v-timeline>

    </vue-scroll>
  </div>
</template>

<script>

import UserInfo from "./UserInfo"
import {aircraftConfig} from "../config";
import GraduationIcon from "./Icon/GraduationIcon";
import {ExamMode, procedureTeacher} from "../modules/ProcedureTeacher";

export default {
  props: {
    procedures: {
      type: Array,
      required: true
    }
  },
  computed: {
    aircraftName() {
      return aircraftConfig.getConfig().name
    },
    isCompleted() {
      return procedure => this.$store.state.completed_procedures.find(p => p.procedure === procedure.name)
    },
    blindExamMode(){
      return procedureTeacher.examMode === ExamMode.blind;
    }
  },
  methods: {
    screenOff() {
      this.$emit("screenSwitch", {value: false, procedure: null});
    },
    startSlider(procedure) {
      this.$emit("screenSwitch", {value: false, procedure});
    },
    toggleBlindExamMode(isBlindExam){
      procedureTeacher.examMode = isBlindExam ? ExamMode.blind : ExamMode.guide;
    }
  },
  components: {
    GraduationIcon,
    UserInfo,
  },
};
</script>

<style scoped lang="less">
@import "../assets/lufthansacolors";
.mainframe {
  position: fixed;
  height: 90vh;
  width: 90vw;
  top: 5vh;
  left: 5vw;
  box-shadow: 20px 20px 20px 20px rgba(0, 0, 0, 0.5);
  border: 4px solid rgb(94, 141, 168);
  border-radius: 10px;
  /*background-image: linear-gradient(to bottom, #dbecff, #91a9c5);*/
  font-family: Roboto, sans-serif;
  overflow: hidden;
  background-color: white;
}

.mainframe .title {
  display: flex;
  flex-direction: row;
  h3{
    padding: 1em;
    display: inline-block;
    flex-grow: 1;
  }
}

.mainframe .title a {
  text-decoration: none;
}

.mainframe .title a button {
  color: white;
  line-height: inherit;
  margin: auto 0;
}

.mainframe .title h3 {
  margin-right: .5em;
  -webkit-text-stroke: 1px @lh-skyblue1; /* width and color */
  color: #0e0404;
}

.mainframe .list-item {

  padding: 0 2em;

}
.blind_exam_button{
  margin-right: 15px;
}

</style>
